<footer>
    <div class="licences">
        <p><a href="https://www.flaticon.com/free-icons/retro" title="retro icons">Retro icons created by Freepik - Flaticon</a><br>
        <a href="http://loading.io" title="loading icons">Loading animations provided by loading.io</a></p>
    </div>
</footer>

<style>
    footer {
        background-color: #191414;
        height: 35vh;
        color: #ffffff;
        padding: 1em;
        display: flex;
        justify-content: center;
    }

    .licences {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }

    .licences p {
        font-size: 0.7em;
    }

    a {
        color:#ffffff73;
    }
</style>